import { Navigate, Route, Routes } from 'react-router-dom'
import { useInvoiceDataContext } from '../../../pages/InvoiceData/Providers/InvoiceDataContextProvider'
import { invoiceDataRoutes } from './routes'

export const InvoiceDataRouter = () => {
  const { state } = useInvoiceDataContext()
  return (
    <Routes>
      {invoiceDataRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={<route.component />}
        />
      ))}
      <Route index element={<Navigate to={state.tabs[0].key} replace />} />
    </Routes>
  )
}
